var _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 114,
    viewBox: "0 0 134 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5796 23.9945C55.5796 19.3792 59.321 15.6377 63.9364 15.6377H124.54V105.013C124.54 109.629 120.799 113.37 116.184 113.37H55.5796V23.9945Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43 15.6377H125.317C129.933 15.6377 133.674 19.3792 133.674 23.9945V48.8401C133.674 53.4554 129.933 57.1969 125.317 57.1969H120.43V15.6377Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.4536,
    y: 31.6221,
    width: 45.2127,
    height: 12.3307,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.319824,
    y: 0.635742,
    width: 76.0372,
    height: 100.823,
    rx: 3.03883,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5642,
    y: 45.3105,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5642,
    y: 54.6602,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5642,
    y: 64.0088,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5642,
    y: 73.3584,
    width: 35.6221,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0807 23.937V24.7665C33.0807 25.866 33.0807 27.1005 32.7239 28.9619L31.4893 28.8365C31.8221 27.1776 31.8366 25.9431 31.8462 24.9111H26.6766V23.937H33.0807ZM33.8523 29.8782V30.8812H25.8472V29.8782H28.7117V26.8594H29.9365V29.8782H33.8523ZM42.4168 29.9167V30.9005H34.3828V29.9167H37.7391V27.9299H38.964V29.9167H42.4168ZM39.0026 24.3035C39.0026 25.5573 40.131 26.8786 42.1371 27.1873L41.6163 28.2096C40.0731 27.9299 38.9254 27.1053 38.3467 26.0106C37.7681 27.1005 36.63 27.9347 35.0965 28.2096L34.5757 27.1873C36.5625 26.8786 37.6813 25.5477 37.6909 24.3035V23.6766H39.0026V24.3035ZM47.9047 23.7634V24.7472H46.159C46.1686 25.7695 46.781 26.7581 48.1843 27.168L47.596 28.1325C46.6267 27.8383 45.9564 27.25 45.5706 26.4929C45.18 27.3802 44.4663 28.0842 43.4102 28.4314L42.7833 27.4573C44.2397 26.9992 44.8955 25.8611 44.9148 24.7472H43.1209V23.7634H47.9047ZM49.8818 23.1751V25.2101H51.0681V26.2132H49.8818V28.3832H48.6473V23.1751H49.8818ZM47.0077 28.5568C48.8305 28.5472 49.9686 29.1741 49.9686 30.2447C49.9686 31.3152 48.8305 31.9518 47.0077 31.9518C45.1463 31.9518 43.9985 31.3152 43.9985 30.2447C43.9985 29.1741 45.1463 28.5472 47.0077 28.5568ZM47.0077 29.5117C45.8503 29.5117 45.2234 29.7528 45.2331 30.2447C45.2234 30.7462 45.8503 30.9969 47.0077 30.9969C48.1458 30.9969 48.7534 30.7462 48.7534 30.2447C48.7534 29.7528 48.1458 29.5117 47.0077 29.5117Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_424",
    x: 0.319824,
    y: 0.635742,
    width: 82.1148,
    height: 106.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.03883,
    dy: 3.03883
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51941
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_424",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceMain);
export default __webpack_public_path__ + "static/media/IcComplaintServiceMain.004f72e89c85d335a0ccfc911c6a1eb2.svg";
export { ForwardRef as ReactComponent };